/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { DietaryTargetsResponse } from './dietary-targets-response';
// May contain unused imports in some cases
// @ts-ignore
import { PlanOptionSubscriptionDetailResponse } from './plan-option-subscription-detail-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionActionResponse } from './subscription-action-response';

/**
 * 
 * @export
 * @interface SubscriptionDetailResponse
 */
export interface SubscriptionDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDetailResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'status'?: SubscriptionDetailResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'partnerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'partnerName'?: string;
    /**
     * 
     * @type {PlanOptionSubscriptionDetailResponse}
     * @memberof SubscriptionDetailResponse
     */
    'planOption'?: PlanOptionSubscriptionDetailResponse;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailResponse
     */
    'remainingDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailResponse
     */
    'daysToStart'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailResponse
     */
    'assignedDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDetailResponse
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'cancellationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailResponse
     */
    'invoiceId'?: string;
    /**
     * 
     * @type {Array<SubscriptionActionResponse>}
     * @memberof SubscriptionDetailResponse
     */
    'actions'?: Array<SubscriptionActionResponse>;
    /**
     * 
     * @type {DietaryTargetsResponse}
     * @memberof SubscriptionDetailResponse
     */
    'dietaryTargets'?: DietaryTargetsResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionDetailResponse
     */
    'deliveryDays'?: Array<SubscriptionDetailResponseDeliveryDaysEnum>;
}

export const SubscriptionDetailResponseStatusEnum = {
    Active: 'ACTIVE',
    Future: 'FUTURE',
    Past: 'PAST',
    Cancelled: 'CANCELLED'
} as const;

export type SubscriptionDetailResponseStatusEnum = typeof SubscriptionDetailResponseStatusEnum[keyof typeof SubscriptionDetailResponseStatusEnum];
export const SubscriptionDetailResponseDeliveryDaysEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type SubscriptionDetailResponseDeliveryDaysEnum = typeof SubscriptionDetailResponseDeliveryDaysEnum[keyof typeof SubscriptionDetailResponseDeliveryDaysEnum];


